// extracted by mini-css-extract-plugin
export default {"pane":"VGHdNTVb","radio":"_2_QVkYwX","checkbox":"gN5qfTgR"};